import { ButtonHTMLAttributes, InputHTMLAttributes } from "react";

import AuthTransition from "@/components/auth/AuthTransition";

export function AuthInput({ className = "", ...props }: InputHTMLAttributes<HTMLInputElement>) {
  return (
    <input
      {...props}
      className={`block w-full px-4 py-3 border border-gray-200 rounded-xl shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-lg bg-white/50 backdrop-blur-sm transition-shadow duration-200 enabled:hover:shadow-md disabled:bg-gray-100 disabled:text-gray-500 disabled:cursor-not-allowed text-left rtl:text-right ${className}`}
    />
  );
}

export function AuthSubmitButton({
  className = "",
  type = "submit",
  ...props
}: ButtonHTMLAttributes<HTMLButtonElement>) {
  return (
    <button
      {...props}
      type={type}
      className={`relative w-full cursor-pointer flex items-center justify-center py-3 px-12 mt-6 border border-transparent rounded-xl shadow-lg text-lg font-semibold text-white bg-origin-border bg-no-repeat bg-gradient-to-r from-primary-light to-primary hover:from-primary-light hover:to-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary disabled:opacity-50 disabled:cursor-not-allowed transition-shadow duration-200 motion-reduce:transition-none ${className}`}
    />
  );
}

export function AuthFormError({ message, visible }: { message: string; visible: boolean }) {
  return (
    <div role="alert" aria-hidden={!visible}>
      <AuthTransition in={visible}>
        <p className="pt-4 text-sm text-red-600 text-center">{message}</p>
      </AuthTransition>
    </div>
  );
}
